import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=5d2c8956"
import script from "./BubbleChart.vue?vue&type=script&lang=js"
export * from "./BubbleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports